export default __webpack_public_path__ + "static/media/skey-network-splash.f902fd81.svg";